import React, { useEffect, useState } from 'react'
import './ProductSuite.css'
import PortalHeader from '../../client-dashboard/clientNavbar/PortalHeader';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Auth';

// Icons
import { IoIosLock } from "react-icons/io";

// Assets
import foreFlightImg from '../client-dashboard-assets/product-suit-assets/fore-flight.png'
import foreFlightLogo from '../client-dashboard-assets/product-suit-assets/fore-flight-logo.png'

import fiResponseImg from '../client-dashboard-assets/product-suit-assets/firesponse-img.jpg'
import fiResponseLogo from '../client-dashboard-assets/product-suit-assets/firesponse-logo.png'

import intterraImg from '../client-dashboard-assets/product-suit-assets/intterra-img.png'
import intterraLogo from '../client-dashboard-assets/product-suit-assets/intterra-logo.png'

import alertwestImg from '../client-dashboard-assets/product-suit-assets/alertwest-img.jpg'
import alertwestLogo from '../client-dashboard-assets/product-suit-assets/alertwest-logo.png'

import gridosImg from '../client-dashboard-assets/product-suit-assets/gridos-img.jpg'
import gridosLogo from '../client-dashboard-assets/product-suit-assets/gridos-logo.png'

import apiendpointImg from '../client-dashboard-assets/product-suit-assets/apiendpoint-img.jpg'
import apiendpointLogo from '../../pages/HeaderFolder/img/FNNLogoWithWhiteFont-07.png'

import emaildispatchImg from '../client-dashboard-assets/product-suit-assets/emaildispatch-img.png'
import hrlforecastImg from '../client-dashboard-assets/product-suit-assets/hrlforecast-img.jpg'
import firespreadImg from '../client-dashboard-assets/product-suit-assets/firespread-img.jpg'
import rawDataImg from '../client-dashboard-assets/product-suit-assets/rawdata-img.jpg'

import cameraImg from '../client-dashboard-assets/product-suit-assets/camera-img.png'

const normalize = (text: string) =>
    text.replace(/™/g, '').toLowerCase().trim();


const ProductSuite = () => {

    // Ensure the page always start at the top
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);

    const [showPopup, setShowPopup] = useState(false);
    const { organization_permissions } = useAuth();

    // Normalize permissions
    const normalizedPermissions = organization_permissions.map(normalize);

    // Build and sort products
    const products = [
        { title: 'ForeFlight', image: foreFlightImg, logo: foreFlightLogo, linkTo: '/fnn_portal_product_suite/foreflight' },
        { title: 'fiResponse', image: fiResponseImg, logo: fiResponseLogo, linkTo: '/fnn_portal_product_suite/firesponse' },
        { title: 'Intterra', image: intterraImg, logo: intterraLogo, linkTo: '/fnn_portal_product_suite/intterra' },
        { title: 'AlertWest', image: alertwestImg, logo: alertwestLogo, linkTo: '/fnn_portal_product_suite/alertwest' },
        { title: 'GridOS ADMS', image: gridosImg, logo: gridosLogo, linkTo: '/fnn_portal_product_suite/gridos-adms' },
        { title: 'API Endpoint', image: apiendpointImg, logo: apiendpointLogo, linkTo: '/fnn_portal_product_suite/api-endpoint' },
        { title: 'Email Dispatch', image: emaildispatchImg, logo: apiendpointLogo, linkTo: '/fnn_portal_product_suite/email-dispatch' },
        { title: 'HRL™ Forecast', image: hrlforecastImg, logo: apiendpointLogo, linkTo: '/fnn_portal_product_suite/hrl-forecast' },
        { title: 'FireSpread Model', image: firespreadImg, logo: apiendpointLogo, linkTo: '/fnn_portal_product_suite/firespread-model' },
        { title: 'HRL Detector Data', image: rawDataImg, logo: apiendpointLogo, linkTo: '/fnn_portal_product_suite/hrl_detector_data' },
        { title: 'Camera Data', image: cameraImg, logo: apiendpointLogo, linkTo: '/fnn_portal_product_suite/camera_data' },
    ].map(product => ({
        ...product,
        isLocked: !normalizedPermissions.includes(normalize(product.title))
    })).sort((a, b) => Number(a.isLocked) - Number(b.isLocked)); // unlocked first, locked last

    return (
        <div className='product-suite-wrapper'>

            <PortalHeader />

            <h1>Your High-Risk-Lightning™ Data, Integrated Across Tools You Already Use</h1>

            <div className='product-suite-card-stack'>
                {/* {products.map((product, index) => (
                    <Link
                        to={product.linkTo}
                        key={index}
                        className='product-suite-card-link'
                        style={{ textDecoration: 'none' }}
                    >
                        <div className='product-suite-card'>
                            <div className='product-suite-card-img-wrapper'>
                                <img src={product.image} alt={`${product.title} screenshot`} />
                            </div>
                            <div className='product-suite-card-inner'>
                                <img
                                    src={product.logo}
                                    alt={`${product.title} logo`}
                                    style={{
                                        filter:
                                            product.title === 'ForeFlight' || product.title === 'GridOS ADMS'
                                                ? 'brightness(0) invert(1)'
                                                : 'none',
                                        maxWidth: product.title === 'ForeFlight' ? '12rem' : undefined,
                                    }}
                                />
                                <h2>{product.title}</h2>
                            </div>
                        </div>
                    </Link>
                ))} */}

                {products.map((product, index) => {
                    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        if (product.isLocked) {
                            e.preventDefault();
                            setShowPopup(true);
                        }
                    };

                    return (
                        <Link
                            to={product.isLocked ? "#" : product.linkTo}
                            onClick={handleClick}
                            key={index}
                            className='product-suite-card-link'
                            style={{ textDecoration: 'none' }}
                        >
                            <div className='product-suite-card'>
                                <div className='product-suite-card-img-wrapper'>
                                    <img src={product.image} alt={`${product.title} screenshot`} />
                                </div>

                                <div className='product-suite-card-inner'>
                                    <img
                                        src={product.logo}
                                        alt={`${product.title} logo`}
                                        style={{
                                            filter:
                                                product.title === 'ForeFlight' || product.title === 'GridOS ADMS'
                                                    ? 'brightness(0) invert(1)'
                                                    : 'none',
                                            maxWidth: product.title === 'ForeFlight' ? '12rem' : undefined,
                                        }}
                                    />
                                    <h2>{product.title}</h2>
                                </div>

                                {/* If locked, show overlay and lock */}
                                {product.isLocked && (
                                    <>
                                        <div className="product-suite-card-overlay" />
                                        <IoIosLock className="product-suite-card-lock-icon" />
                                    </>
                                )}
                            </div>
                        </Link>

                    );
                })}




            </div>

            {showPopup && (
                <div className="suite-popup-overlay">
                    <div className="suite-popup-content">
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }} className='faq-adjust-buttons suite-extension'>
                            <button
                                style={{ paddingLeft: '1rem', paddingRight: '1rem' }}
                                onClick={() => setShowPopup(false)}
                            >
                                <strong>Back</strong>
                            </button>
                        </div>

                        <h1>You Do Not Have Access to This Feature</h1>
                        <IoIosLock className='lock-icon-popup' />
                        <p>This feature is part of a higher-tier plan and isn’t available with your current subscription.</p>
                        <p>To unlock access, you can speak with an FNN representative to discuss your options.</p>
                        <Link to='/fnn_portal_representative'>
                            <button className='suite-popup-content-btn'>Contact Us</button>
                        </Link>
                    </div>
                </div>
            )}

        </div>
    )
}

export default ProductSuite
